<ngrx-busy>
  @if (tree$ | async; as tree) {
    <mat-card class="container">
      <div class="total">
        <div class="distance">
          {{(tree.walk_distance / 1000)  | number: '1.0-1':'en'}} km
          <small>Total for {{tree.days}} days</small>
        </div>
        <div class="total-stats">
          <div class="total-stats-item">
            {{tree.walk_amount}} <small>walks</small>
          </div>
          <div class="total-stats-item">
            {{(tree.walk_avg_distance / 1000)  | number: '1.0-1':'en'}} <small>avg. km</small>
          </div>
          <div class="total-stats-item">
            {{tree.walk_avg_steps}} <small>avg. steps</small>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="month">
        <mat-form-field appearance="fill" class="month-form">
          <!--          <mat-label>Select an option</mat-label>-->
          <mat-select [formControl]="monthCtrl">
            @for (yearSet of tree.years; track yearSet) {
              <mat-optgroup
                label="{{yearSet.year}}">
                @for (monthSet of yearSet.months; track monthSet) {
                  <mat-option
                    [value]="monthSet">
                    {{monthSet.date | moment:'MMMM, yyyy'}}
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
        @if (monthCtrl.value) {
          <div
            class="month-stats">
            {{monthCtrl.value.walk_amount}} walks, {{(monthCtrl.value.walk_distance / 1000) | number: '1.0-1':'en'}} km
          </div>
        }
      </div>
      <mat-divider></mat-divider>
      <div class="walks">
        <div class="walks-scroll">
          @for (day of (timeline$ | async) | keyvalue: compareDay; track day; let i = $index) {
            @if (i != 0) {
              <mat-divider></mat-divider>
            }
            @for (item of day.value; track item) {
              @switch (item.type) {
                @case ('walk') {
                  <a
                    [routerLink]="['tracks', item.id]"
                    [routerLinkActive]="['active']"
                    (click)="selectWalk($event)"
                    class="walk">
                    <div class="map">
                      <img [src]="item.preview || '/assets/images/preview_not_available.svg'"
                        onerror="this.src='/assets/images/preview_not_available.svg';"/>
                    </div>
                    <div class="info">
                      @if (!item.ended_at) {
                        <div
                          class="in-progress">
                          <mat-icon>timelapse</mat-icon>
                          <span>In progress</span>
                        </div>
                      }
                      <span class="started">
                        <zoned-time [time]="item.started_at"
                          [zone]="item.started_at_zone"
                        format="MMM D, LT"></zoned-time>
                      </span>
                      <div class="description">
                        <mat-icon>pets</mat-icon>
                        <span>{{(item.distance / 1000) | number:'1.0-1':'en'}} km,&nbsp;</span>
                        <span>{{item.duration | moment:'HH:mm:ss'}}</span>
                      </div>
                      <span class="steps">{{item.steps | number:'1.0-0':'fr-FR'}} steps</span>
                      <div class="walkers">
                        @for (walker of item.walkers; track walker) {
                          <img
                            [src]="(walker.avatar || '/assets/images/profile.jpg') + '?size=small&scale=2'"
                            [matTooltip]="walker.full_name"
                            onerror="this.src='/assets/images/profile.jpg';"
                            class="walker"/>
                        }
                      </div>
                      @if (!!item.achievements.length) {
                        <div
                          class="achievements">
                          <mat-icon svgIcon="trophy"></mat-icon>
                          @if (item.achievements.length > 1) {
                            <span
                            class="achievements-amount">{{item.achievements.length}}</span>
                          }
                        </div>
                      }
                    </div>
                  </a>
                }
                @case ('rest') {
                  <a
                    [routerLink]="['traces', item.id]"
                    [routerLinkActive]="['active']"
                    (click)="selectWalk($event)"
                    class="walk">
                    <div class="map">
                      <img [src]="item.preview || '/assets/images/preview_not_available.svg'"
                        onerror="this.src='/assets/images/preview_not_available.svg';"/>
                    </div>
                    <div class="info">
                      @if (!item.ended_at) {
                        <div
                          class="in-progress">
                          <mat-icon>timelapse</mat-icon>
                          <span>In progress</span>
                        </div>
                      }
                      <span class="started">
                        <zoned-time [time]="item.started_at"
                          [zone]="item.started_at_zone"
                        format="MMM D, LT"></zoned-time>
                      </span>
                      <div class="description">
                        <mat-icon class="type">home</mat-icon>
                        <span>{{(item.distance / 1000) | number:'1.0-1':'en'}} km,&nbsp;</span>
                        <span>{{item.duration | moment:'HH:mm:ss'}}</span>
                      </div>
                      <span class="steps">{{item.steps | number:'1.0-0':'fr-FR'}} steps</span>
                    </div>
                  </a>
                }
                @case ('rejected_track') {
                  <a
                    [routerLink]="['tracks', item.id]"
                    [routerLinkActive]="['active']"
                    (click)="selectWalk($event)"
                    class="rejected-track">
                    <mat-icon class="type">pets</mat-icon>
                    <span class="started">
                      <zoned-time [time]="item.started_at"
                        [zone]="item.started_at_zone"
                      format="MMM D, LT"></zoned-time>
                    </span>
                    <span>Rejected by {{item.rejected_reason | humanize:'track_rejected_reason'}}</span>
                  </a>
                }
              }
            }
          }
        </div>
      </div>
    </mat-card>
  }
</ngrx-busy>
